import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import Panel from '@/components/Panel';
import { resetFlow } from '@/slices/execFlowSlice';
import { isVoid } from '@/utils/common';
import FlowSteps from './FlowSteps';
import SelectCluster from './SelectCluster';
import UploadPackages from './UploadPackages';

function FlowExecuteDetail({ resetFlow, clusterId }) {
  useEffect(() => {
    return () => {
      resetFlow();
    };
  }, [resetFlow]);

  return (
    <Panel style={{ marginRight: 20 }}>
      <SelectCluster />
      {!isVoid(clusterId) && (
        <>
          <UploadPackages />
          <FlowSteps />
        </>
      )}
    </Panel>
  );
}

export default connect(
  (state) => ({
    clusterId: state.execFlow.currentCluster?.id,
  }),
  {
    resetFlow,
  },
)(FlowExecuteDetail);
